import React from 'react';

import { AppSettings } from '@/app/AppSettings';
import { HighlightableJson } from '@/app/log-viewer/highlighting/HighlightableJson';
import { LogEntry, LogEntryType } from '@/parsing/LogEntry';
import { JqSafeInput } from '@/util/jqSafe';

import { LogEntryCellModel, LogEntryCellModelData, LogEntryCellType } from '../LogEntryCellModel';
import { JsonViewer } from './components/JsonViewer';

export interface NetworkBodyWithJqCellModelData extends LogEntryCellModelData {
  jqInput: JqSafeInput;
  jqQuery: string;

  processedJqResult?: {
    jqQuery: string;
    highlightableJson: HighlightableJson;
  };
}

export interface NetworkBodyWithJqCellModel extends LogEntryCellModel {
  data: NetworkBodyWithJqCellModelData;

  onRequestCreateNewColumn?: (jqQuery: string) => void;
  updateJqQuery(jqQuery: string): void;
}

export abstract class NetworkBodyWithJqCellModelFactory {
  static make(logEntry: LogEntry, jqQuery: string): NetworkBodyWithJqCellModel {
    return new NetworkBodyWithJqCellModelImpl(logEntry, jqQuery);
  }
}

class NetworkBodyWithJqCellModelImpl implements NetworkBodyWithJqCellModel {
  private logEntry: LogEntry;

  data: NetworkBodyWithJqCellModelData;

  applySettings(_s: AppSettings) {}

  onRequestCreateNewColumn?: (jqQuery: string) => void;

  constructor(logEntry: LogEntry, jqQuery: string) {
    this.logEntry = logEntry;
    this.data = {
      type: LogEntryCellType.NetworkBodyWithJq,
      jqQuery,
      jqInput:
        logEntry.entryType === LogEntryType.NetworkRequest
          ? {
              original: logEntry.extra.networkRequest?.request?.body,
              json: logEntry.extra.networkRequest?.request?.bodyJson,
            }
          : {
              original: logEntry.extra.networkRequest?.response?.body,
              json: logEntry.extra.networkRequest?.response?.bodyJson,
            },
    };
  }

  updateJqQuery(jqQuery: string) {
    this.data.jqQuery = jqQuery;
    this.data.processedJqResult = undefined;
  }
}

export class NetworkBodyWithJqCell extends React.Component<{ model: NetworkBodyWithJqCellModel }> {
  render() {
    const data = this.props.model.data;

    return (
      <div>
        {data.processedJqResult ? (
          <JsonViewer
            highlightableJson={data.processedJqResult.highlightableJson}
            onDataChange={(jsonChange) => {
              const change: DeepPartial<NetworkBodyWithJqCellModelData> = {
                processedJqResult: {
                  highlightableJson: jsonChange,
                },
              };
              this.props.model.delegate?.onLogEntryCellModelChange({
                cellModel: this.props.model,
                change,
                postProcess: false,
              });
            }}
            onCopyJqPath={(p) => {
              const jqPath = data.jqQuery + p;
              navigator.clipboard.writeText(jqPath);
            }}
            onExtractNewColumn={(p) => {
              const jqPath = data.jqQuery + p;
              const c = this.props.model.onRequestCreateNewColumn;
              if (c) {
                c(jqPath);
              }
            }}
          />
        ) : null}
      </div>
    );
  }
}
